import { useEffect, useState } from 'react'

/** `false` while the browser tab is hidden, so pollers can pause. */
export function usePageVisible(): boolean {
  const [visible, setVisible] = useState(() => document.visibilityState !== 'hidden')

  useEffect(() => {
    const handleChange = () => setVisible(document.visibilityState !== 'hidden')
    document.addEventListener('visibilitychange', handleChange)
    return () => document.removeEventListener('visibilitychange', handleChange)
  }, [])

  return visible
}
